var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 12"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 8",
    cx: 14,
    cy: 14,
    r: 2.00877,
    stroke: "#EAEAEA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 13.9999,
    cy: 13.9999,
    r: 9.02632,
    stroke: "#EAEAEA",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 44",
    x: 0.666748,
    y: 12.4999,
    width: 4.44444,
    height: 3,
    rx: 1.5,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45",
    x: 22.8889,
    y: 12.4999,
    width: 4.44444,
    height: 3,
    rx: 1.5,
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 46",
    x: 15.5,
    y: 22.8887,
    width: 4.44444,
    height: 3,
    rx: 1.5,
    transform: "rotate(90 15.5 22.8887)",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 47",
    x: 15.5002,
    y: 0.666626,
    width: 4.44444,
    height: 3,
    rx: 1.5,
    transform: "rotate(90 15.5002 0.666626)",
    fill: "#EAEAEA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/Target.f96bb57fdccd24f4962b1b023516d93d.svg";
export { ForwardRef as ReactComponent };